<template>
    <div class="recharge_order-container">
        <order-list :order-type="0"></order-list>
    </div>
</template>

<script>
    import OrderList from './OrderList'

    export default {
        name: 'RechargeOrder',
        components: {OrderList},
        data () {
            return {}
        },
        mounted () {},
        methods: {}
    }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/order/RechargeOrder.vue